import { Input } from "antd";
import { NumberInput } from "./NumberInput";
import { FieldWrapper } from "../common/FieldWrapper";
const { TextArea } = Input;

export const TextInput = ({
  placeholder,
  label,
  rows,
  suffix,
  prefix,
  helperText,
  type,
  required = false,
  onChange: handleChange, // handles form input change events
  updateChanges,
  value,
  numberValue,
  name,
  error,
  ...props
}: {
  placeholder?: any;
  label?: any;
  rows?: any;
  suffix?: any;
  prefix?: any;
  helperText?: any;
  type?: any;
  required?: any;
  onChange?: any;
  updateChanges?: any;
  value?: any;
  numberValue?: any;
  name?: any;
  error?: any;
}) => {
  const onChange = (event: any) => {
    handleChange(event);
    const { name, value } = event.target;
    const values = { [name]: value };
    if (updateChanges) updateChanges(values);
  };

  const inputOptions = {
    name,
    onChange,
    placeholder: placeholder || label,
    addonAfter: suffix,
    value,
    type,
    addonBefore: prefix,
    required,
  };

  return (
    <FieldWrapper
      field={name}
      {...{ label, helperText, error, required }}
      {...props}
    >
      {rows ? (
        <TextArea {...inputOptions} rows={rows || 2} />
      ) : type === "password" ? (
        <Input.Password {...inputOptions} {...props} />
      ) : type === "number" ? (
        <NumberInput
          {...{
            onChange,
            name,
            value,
            placeholder: placeholder || label,
            addonBefore: prefix,
            addonAfter: suffix,
          }}
          {...props}
          value={numberValue || value}
        />
      ) : (
        <Input {...inputOptions} {...props} />
      )}
    </FieldWrapper>
  );
};
